export const composeDiscardButton = "AgtUKb";
export default {composeDiscardButton};